import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';
import SectionTitle1 from '../../elements/section-title/SectionTitle1';

const Datas = [
    {
        id: 1,
        title: "Expertise",
        para: "Our team of professionals brings years of industry experience to provide innovative and effective facility management services."
    },
    {
        id: 2,
        title: "Reliability & Efficiency",
        para: "We prioritize reliability and efficiency in our operations, ensuring seamless facility management services that enhance the functionality and longevity of your property."
    },
    {
        id: 3,
        title: "Commitment to Quality",
        para: "With a focus on excellence, we maintain high standards in service delivery, ensuring your space is safe and well-maintained."
    },
    {
        id: 4,
        title: "Technology-Driven",
        para: "We leverage the latest tools and technologies to deliver efficient, sustainable, and future-ready solutions."
    },
    {
        id: 5,
        title: "Customer-Centric Approach",
        para: "Your satisfaction is our priority, and we are committed to providing responsive and reliable support every step of the way."
    },
    {
        id: 6,
        title: "Sustainability Focus",
        para: "We are committed to sustainable practices, incorporating energy-efficient solutions, waste reduction, and environmentally friendly technologies into our operations "
    }
]




const AboutThree = () => {
    return (
        <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20">
            <div className="container">
                <SectionTitle1 
                    subtitle="Our Values"
                    title="Why choose us?"
                    description="With 19+ years of experience, UCWF Facilities Management delivers top-tier integrated FM solutions across the UAE. We help businesses maintain efficient, safe, and sustainable environments, ensuring optimal asset performance across commercial, residential, industrial, and hospitality sectors. Our expertise goes beyond maintenance—we focus on proactive asset management, energy efficiency, and cost-effective solutions, leveraging cutting-edge technology and sustainability-driven practices. Committed to quality, compliance, and safety, we build long-term partnerships by providing tailored FM solutions that align with your business goals."
                    description2="Here’s why UCWF is the right partner for your facilities management needs: "
                    textAlignment="heading-left heading-light-left mb--100"
                    textColor=""
                />

                <div className="row">
                    {Datas.map((data) => (
                        <div className="col-lg-4" key={data.id}>
                            <div className="about-quality">
                                <h3 className="sl-number h3">{data.id}</h3>
                                <h5 className="title">{data.title}</h5>
                                <p>{data.para}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            {/* <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-1.png"} alt="Circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/line-3.png"} alt="Circle" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"} alt="Circle" /></li>
            </ul> */}
        </div>
    )
}

export default AboutThree;